import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ControlledMenu, useClick, useMenuState } from "@szhsin/react-menu";
import classNames from "classnames";
import React from "react";
import cls from "./button-dropdown.module.scss";
import { MenuDropdownContext, usePortalContainer } from "./MenuContext";
import { SubMenu } from "./SubMenu";
import { MenuItem } from "./MenuItem";
export function MenuDropdown(props) {
    const { openStateClassName = "focus", menuClassName = cls.menu, menuItemClassName = cls.menuItem, menuItemHoverClassName = cls.menuItemHover, menuItemDisabledClassName = cls.menuItemDisabled, menuItemWithSubMenuClassName = cls.menuItemWithSubMenu, children, ...rest } = props;
    const [menuButton, menuChildren] = children;
    const ref = React.useRef(null);
    const [menuState, toggleMenu] = useMenuState({ transition: true });
    const anchorProps = useClick(menuState.state, toggleMenu);
    const getButton = () => {
        if (typeof menuButton === "function") {
            const jsx = menuButton({ open: menuState.state === "open" });
            return React.cloneElement(jsx, { ref: ref, ...anchorProps });
        }
        else {
            return React.cloneElement(menuButton, {
                ref: ref, ...anchorProps,
                className: classNames(menuButton.props.className, { [openStateClassName]: menuState.state === "open" })
            });
        }
    };
    const button = getButton();
    const container = usePortalContainer(menuState.state);
    return _jsxs(MenuDropdownContext.Provider, { value: { menuClassName, menuItemClassName, menuItemHoverClassName, menuItemDisabledClassName, menuItemWithSubMenuClassName }, children: [button, _jsx(ControlledMenu, { ...rest, menuClassName: menuClassName, onClose: () => toggleMenu(false), anchorRef: ref, ...menuState, transition: true, portal: { target: container }, initialMounted: false, unmountOnClose: true, children: menuChildren })] });
}
MenuDropdown.SubMenu = SubMenu;
MenuDropdown.MenuItem = MenuItem;
